<h2>Kunduppgifter</h2>
<div class="applicant">
  <div class="row">
    <spb-read-only label="Personnummer"
                   [value]="kycService.kycModel.sub"
    />
  </div>

  <div class="row">
    <spb-read-only label="Förnamn"
                   [value]="kycService.kycModel.firstName"
    />
    <spb-read-only label="Mellannamn"
                   [value]="kycService.kycModel.otherGivenNames"
    />
    <spb-read-only
      label="Efternamn" [value]="kycService.kycModel.lastName"
    />
  </div>


  <div class="row">
    <spb-read-only
      label="Folkbokföringsadress"
      [value]="kycService.kycModel.addressLine"
    />
    @if (kycService.kycModel.coName) {
      <spb-read-only
        label="c/o adress"
        [value]="kycService.kycModel.coName"
      />
    }

    @if (kycService.kycModel.country !== 'SE') {
      <spb-read-only
        label="Utländsk adress"
        [value]="'kycService.kycModel'"
      />
    }
    <spb-read-only
      label="Postnummer"
      [value]="kycService.kycModel.postalCode"
    />
    <spb-read-only
      label="Ort"
      [value]="kycService.kycModel.postalTown"
    />
    <spb-read-only
      label="Land"
      [value]="country()!"
    />
  </div>

  <div class="row">
    <spb-mobile-area-code (valid)="valids[0].set($event)"/>

    <spb-mobile (valid)="valids[1].set($event)"/>

    <spb-private-email (valid)="valids[2].set($event)"/>
  </div>

</div>